import { Map } from 'immutable';
import core from './core';

const INITIAL_STATE = new Map({
    list: new Map(),
    initialized: false
});

export default function ticketing(state = INITIAL_STATE, action) {
    switch (action.type) {
        case 'FHE__SET_PRODUCTS':
            return core.setProducts(state, action.products);
        case 'FHE__UPDATE_PRODUCTS':
            return core.updateProducts(state, action.products);
        case 'FHE__UPDATE_HOME_PRODUCTS':
            return core.updateProducts(state, action.products);
        case 'FHE__SET_PRODUCT_DETAILS':
            return core.setProductDetails(state, action.product);
        case 'FHE__SET_NEW_PRODUCT_DETAILS':
            return core.setNewProductDetails(state, action.product);
        case 'FHE__PRODUCT_UPDATE_STATUS':
            return core.setProductStatus(state, action.productKey, action.status);
        case 'FHE__PRODUCT_UPDATE_FIELD':
            return core.updateProductField(state, action.productKey, action.fieldName, action.fieldValue);
        case 'FHE__PRODUCT_DISSOCIATE':
            return core.dissociateProduct(state, action.productKey, action.fieldName, action.fieldValue);
        case 'FHE__PRODUCT_MODULE_UPDATE':
            return core.updateProductModule(state, action.productKey, action.productModuleKey, action.form);
        case 'FHE__FHEPRODUCT_THRESHOLD_UPDATE':
            return core.updateFheProductThreshold(state, action.productKey, action.productModuleKey, action.threshold);
        case 'FHE__FHEPRODUCT_GAIN_UPDATE':
            return core.updateFheProductGain(state, action.productKey, action.productModuleKey, action.gain);
        case 'FHE__FHEPRODUCT_POLARITY_UPDATE':
            return core.updateFheProductPolarity(state, action.productKey, action.productModuleKey, action.polarity);
        case 'FHE__PRODUCT_DELETE':
            return core.deleteProduct(state, action.productKey);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./environments/fhe/data/Products/reducer.js